import styles from './ErrorModalContent.module.scss';
import cx from 'classnames';
import { Button, Icon, Text } from 'components';

type Props = {
  title: string;
  subtitle: string;
  onConfirm(): void;
  contentContainerClassname?: string;
  buttonContainerClassname?: string;
};

export const ErrorModalContent = ({
  title,
  subtitle,
  onConfirm,
  contentContainerClassname,
  buttonContainerClassname,
}: Props) => {
  return (
    <>
      <div className={cx(styles.contentContainer, contentContainerClassname)}>
        <Icon name="X" />
        <Text type="body-big">{title}</Text>
        <Text type="body2">{subtitle}</Text>
      </div>
      <div className={cx(styles.buttonContainer, buttonContainerClassname)}>
        <Button onClick={onConfirm}>Confirm</Button>
      </div>
    </>
  );
};
